import React, { useRef, useEffect, useState } from "react";
import styles from './HierarchyElement.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const HierarchyElement = ({ hierarchyMapping }) => {

    const navigate = useNavigate();

    const scrollContainerRef = useRef(null);

    const [isMobile, setIsMobile] = useState(false);

    // function HandleBreadcrumbsVerticalClick(verticalId) {
    //     if(verticalId){
    //         localStorage.setItem("dla_web_student_selected_vertical",verticalId);
    //     }
    //     window.location = '/';
    // }

    // function HandleBreadcrumbsMiddleClick(NodeId) {
    //     let pathToBeUsed = [];
    //     for (let index = 0; index < hierarchyMapping.length; index++) {
    //         const oneData = hierarchyMapping[index];
    //         pathToBeUsed.push(oneData.id);
    //         if (oneData.id === NodeId) {
    //             break;
    //         }
    //     }

    //     if(pathToBeUsed.length > 0){
    //         localStorage.setItem("dla_web_student_selected_hierarchy",pathToBeUsed.join(','));
    //         window.location = '/explore';
    //     }
    // }
    useEffect(() => {
        const checkScreen = () => setIsMobile(window.innerWidth <= 768);
        checkScreen();
        window.addEventListener("resize", checkScreen);
        return () => window.removeEventListener("resize", checkScreen);
    }, []);

    const handleClick = (path) => {
        navigate(path);
    };

    // step 2: scroll on mount or when hierarchyMapping updates
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollTo({
                    left: scrollContainerRef.current.scrollWidth,
                    behavior: 'smooth',
                });
            }
        }, 0); // waits one tick
      
        return () => clearTimeout(timeout);
    }, [hierarchyMapping]); // trigger on hierarchy change

    return (
        <div 
            ref={scrollContainerRef} 
            className={styles.HierarchyHorizontalDiv} 
            style={{
                gap: isMobile
                ? hierarchyMapping.length <= 2
                    ? '5%'
                    : '17%'
                : undefined
            }}
        >
            {
                hierarchyMapping.map((oneHierarchy, index) => (
                    <div key={index} className={styles.OneHierarchyHorizontalDiv}>
                        {
                            index > 0 
                            &&
                            <FontAwesomeIcon 
                                key={`${index}_icon`}
                                icon={faChevronRight}
                            />
                        }
                        
                        <img 
                            src={oneHierarchy.category_thumbnail_image} 
                            alt=""
                            className={styles.HierarchyIcon}
                            // onClick={(index+1) == hierarchyMapping.length ? () => {} : index == 0 ? () => {HandleBreadcrumbsVerticalClick(oneHierarchy.id)} : () => {HandleBreadcrumbsMiddleClick(oneHierarchy.id)}}
                            onClick={() => handleClick(oneHierarchy.redirection_end_point)}
                        />
                        
                        <span 
                            // onClick={(index+1) == hierarchyMapping.length ? () => {} : index == 0 ? () => {HandleBreadcrumbsVerticalClick(oneHierarchy.id)} : () => {HandleBreadcrumbsMiddleClick(oneHierarchy.id)}}
                            onClick={() => handleClick(oneHierarchy.redirection_end_point)}
                        >
                            {oneHierarchy.category_name_english}
                        </span>
                    </div>
                ))
            }
        </div>
    );
};

export default HierarchyElement;
